import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Table } from 'react-bootstrap';
import { getMostOrderedColors } from 'scenes/Statistics/utils';

const Wrapper = styled.div`
  text-align: center;
  margin-top: 20px;
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.blowSuccess};
  font-size: 35px;
  letter-spacing: 5px;
  font-weight: bold;
`;

const TableContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  margin: 0 auto;
`;

const SortableHeader = styled.th`
  cursor: pointer;
  user-select: none;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const SortIcon = styled.span`
  margin-left: 5px;
  font-size: 12px;
`;

const SORT_KEYS = {
  ordersCount: 'ordersCount',
  totalSurface: 'totalSurface',
  cncSurface: 'cncSurface',
  flatSurface: 'flatSurface',
};

const ColorsTable = ({ orders }) => {
  const [sortBy, setSortBy] = useState('ordersCount');
  const [sortDirection, setSortDirection] = useState('desc');
  const [colors, setColors] = useState([]);

  useEffect(() => {
    if (orders && orders.length > 0) {
      const mostOrderedColors = getMostOrderedColors(orders, 'orders', 40);
      setColors(mostOrderedColors);
    }
  }, [orders]);

  const sortedColors = React.useMemo(() => {
    if (!colors.length) return [];

    return [...colors].sort((a, b) => {
      const aVal = a[sortBy] || 0;
      const bVal = b[sortBy] || 0;
      return sortDirection === 'desc' ? bVal - aVal : aVal - bVal;
    });
  }, [colors, sortBy, sortDirection]);

  const handleSort = (key) => {
    if (sortBy === key) {
      setSortDirection(sortDirection === 'desc' ? 'asc' : 'desc');
    } else {
      setSortBy(key);
      setSortDirection('desc');
    }
  };

  const getSortIcon = (key) => {
    if (sortBy !== key) return <SortIcon>⇅</SortIcon>;
    return <SortIcon>{sortDirection === 'desc' ? '↓' : '↑'}</SortIcon>;
  };

  if (!orders || orders.length === 0) return null;

  return (
    <Wrapper>
      <Title>Najczęściej zamawiane kolory</Title>
      <TableContainer>
        <Table responsive="lg" bordered hover size="sm">
          <thead>
            <tr>
              <th>Lp.</th>
              <th>Kolor</th>
              <SortableHeader
                onClick={() => handleSort(SORT_KEYS.ordersCount)}
              >
                Liczba zamówień {getSortIcon(SORT_KEYS.ordersCount)}
              </SortableHeader>
              <SortableHeader
                onClick={() => handleSort(SORT_KEYS.totalSurface)}
              >
                Razem m<sup>2</sup> {getSortIcon(SORT_KEYS.totalSurface)}
              </SortableHeader>
              <SortableHeader
                onClick={() => handleSort(SORT_KEYS.cncSurface)}
              >
                m<sup>2</sup> CNC {getSortIcon(SORT_KEYS.cncSurface)}
              </SortableHeader>
              <SortableHeader
                onClick={() => handleSort(SORT_KEYS.flatSurface)}
              >
                m<sup>2</sup> gładkie {getSortIcon(SORT_KEYS.flatSurface)}
              </SortableHeader>
            </tr>
          </thead>
          <tbody>
            {sortedColors.map((item, index) => (
              <tr key={item.color}>
                <td>{index + 1}</td>
                <td>{item.color}</td>
                <td>{item.ordersCount}</td>
                <td>{item.totalSurface.toFixed(2)}</td>
                <td>{item.cncSurface.toFixed(2)}</td>
                <td>{item.flatSurface.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </Wrapper>
  );
};

export default ColorsTable;
